module.exports = __webpack_public_path__ + "static/temp-birth-assignment-b5f9c3192b0e4f8697c859f08248dc94.jpg";